import {
  Base64
} from '@/utils/encoding'
import service from './axios'
import moment from 'moment'
import CryptoJs from '../assets/aes.min'

export const login = (account, password, captcha, captchaId) => {
  password = CryptoJs.encrypt(password);
  const data = {
    username: account,
    password: password,
    captchaDTO: {
      captchaId: captchaId,
      captchaText: captcha
    }
  }
  return service({
    url: '/static/public/cg/pcLogin',
    data: data,
    method: 'POST'
  })
}

export const getVeficationCode = () => {
  return service({
    url: '/static/public/cg/generateCaptcha',
    data: {},
    method: 'POST'
  })
}

export const getUserInfo = (token) => {
  return service({
    url: '/static/frontApi/user/getUserInfo',
    data: {
      token: token
    },
    method: 'POST'
  })
}

export const sendMessaheCode = (email) => {
  return service({
    url: '/static/frontIndex/core/getCaptchaByEmail?email=' + email,
    data: {},
    method: 'GET'
  })
}

export const register = (data, captcha, captchaId) => {
  return service({
    url: '/static/public/cg/pcRegister',
    data: {
      flag: data.type == '6' ? 30 : 40,
      fullName: data.name,
      cardType: data.idType,
      cardNum: data.idNumber,
      unit: data.unit,
      password: CryptoJs.encrypt(data.password),
      phone: data.phone,
      email: data.email,
      captchaDTO: {
        captchaText: captcha,
        captchaId: captchaId
      }
    },
    method: 'POST'
  })
}

export const getActivityList = (makeDate) => {
  return service({
    url: `/static/frontResApi/exhibit/findAllExhibitMake/${makeDate}`,
    data: {},
    method: 'POST'
  })
}

export const updatePwd = (oldPwd, newPwd) => {
  return service({
    url: '/static/frontApi/user/operate/changePass',
    data: {
      oldPassword: CryptoJs.encrypt(oldPwd),
      newsPassword: CryptoJs.encrypt(newPwd),
    },
    method: 'POST'
  })
}

export const updateUserInfo = (data) => {
  return service({
    url: '/static/frontApi/user/operate/updateInfo',
    data: data,
    method: 'POST'
  })
}

export const forget = (account, captchaDTO) => {
  return service({
    url: '/static/public/cg/operate/forgetPass',
    data: {
      email: account.email,
      captchaDTO: captchaDTO,
      password: CryptoJs.encrypt(account.password)
    },
    method: 'POST'
  })
}

export const getActivityDetial = (id) => {
  return service({
    url: `/static/frontResApi/exhibit/findExhibitDetails/${id}`,
    data: {},
    method: 'POST'
  })
}

export const getActivityComment = (id, currentPage, pageSize) => {
  return service({
    url: `/static/frontApi/comment/findAllCommentPageByExhId/${id}`,
    data: {
      hallId: id,
      currentPage: currentPage,
      pageSize: pageSize
    },
    method: 'POST'
  })
}

export const oauthLogin = (code) => {
  return service({
    url: `/static/public/cg/pcLoginWrd/${code}`,
    data: {},
    method: 'POST'
  })
}

export const getMyActivityComment = (exhId, params) => {
  return service({
    url: `/static/frontApi/comment/findAllCommentPageByExhId/${exhId}`,
    data: params,
    method: 'POST'
  })
}

/**
 * 预约展览
 * @param {*} date
 * @param {*} dateTime
 * @param {*} hallId
 * @param {*} peopleList
 * @param {*} guide
 */
export const orderActivity = (date) => {
  return service({
    url: `static/frontResApi/make/operate/beginMake/${date.makeDate}`,
    data: {
      ...date,
      exhId: date.exhId,
      filePath: date.filePath,
      followMakeDTOList: date.followMakeDTOList,
      timeSlice: date.timeSlice
    },
    method: 'POST'
  })
}

/**
 * 获取我的记录（违约记录或者预约记录）
 * @param {*} currentPage
 * @param {*} pageSize
 * @param {*} type 1是预约记录 2是违约记录
 */
export const myRecords = (currentPage, pageSize) => {
  return service({
    url: '/static/frontResApi/make/findAllMakeLogPage',
    data: {
      currentPage: currentPage,
      pageSize: pageSize,
      sortField: 'makeDateStr',
      sortType: 'desc'
    },
    method: 'POST'
  })
}

/**
 *
 * @param {预约ID} id
 * @param {类型 0取消预约 1签到 2签退} type
 */
export const oprateActivity = (id, type) => {
  return service({
    url: '/static/frontIndex/api/hall/operate/sign',
    data: {
      id: id,
      type: type
    },
    method: 'POST'
  })
}

/**
 * 预约详情
 * @param {预约ID} id
 */
export const orderDetial = (param) => {
  return service({
    url: `/static/frontResApi/make/findAllMakeLogPage`,
    data: param,
    method: 'POST'
  })
}

/**
 * 预约接口
 * @param {预约ID} id
 */
export const comment = (id, params) => {
  return service({
    url: `/static/frontApi/comment/operate/sendComment/${id}`,
    data: params,
    method: 'POST'
  })
}

/**
 * 获取展厅信息
 * @param {展厅或者展览} id
 */
export const getHallDetail = (id) => {
  // console.log(id);
  return service({
    url: '/static/frontIndex/api/hall/getAreaInfo',
    data: {
      id: id,
    },
    method: 'POST'
  })
}

export const uploadFile = (data) => {
  return service({
    url: '/static/uploadFile',
    data: data,
    method: 'post',
    contentType: 'multipart/form-data'
  })
}


export const sendEmail = (data) => {
  return service({
    url: `/static/public/cg/sendEmil/${data.type}/${data.email}`,
    method: 'post',
    contentType: 'multipart/form-data'
  })
}

//获取带预约信息的展览详情
export const findExhibitMakeDetails = (makeDate, exhId) => {
  return service({
    url: `/static/frontResApi/exhibit/findExhibitMakeDetails/${makeDate}/${exhId}`,
    data: {},
    method: 'POST'
  })
}


//获取随行人员列表
export const findAllFollowPageByMakeId = (id) => {
  return service({
    url: `/static/frontResApi/follow/findAllFollowPageByMakeId/${id}`,
    data: {},
    method: 'POST'
  })
}



//获取随行人员必填列表
export const getFollowData = (id) => {
  return service({
    url: `/static/frontResApi/follow/getFollowData/${id}`,
    data: {},
    method: 'POST'
  })
}


//取消预约
export const cancelMake = (id) => {
  return service({
    url: `/static/frontResApi/make/operate/cancelMake/${id}`,
    data: {},
    method: 'POST'
  })
}


//获取我的违约记录  /static/frontResApi/make/findAllBreachPage
export const findAllBreachPage = (currentPage, pageSize) => {
  return service({
    url: `/static/frontResApi/make/findAllBreachPage`,
    data: {
      currentPage: currentPage,
      pageSize: pageSize
    },
    method: 'POST'
  })
}


//获取当前评论下的回复评论
export const getCommont = (id) => {
  return service({
    url: `/static/frontApi/comment/findAllCommentPageById/${id}`,
    data: {},
    method: 'POST'
  })
}


export const getTimeSlice = (makeDate, exhId) => {
  return service({
    url: `/static/frontResApi/exhibit/getResidueTimeSlice/${makeDate}/${exhId}`,
    method: "POST"
  })
}


// 下载随行人员列表
export const followDownload = (exhId, flag) => {
  return service({
    url: `/static/public/cg/operate/followDownload/${exhId}/${flag}`,
    data: {},
    method: 'Get'
  })
}

// 获取公告
export const getNotice = () => {
  return service({
    url: `/static/public/cg/getNotice`,
    method: 'POST'
  })
}




// 获取校区
export function findAllSchArea () {
  return service({
    url: `/static/frontApi/area/findAllSchArea`,
    method: 'POST'
  })
}
// 获取带预约信息的展览列表
export function findAllExhibitMakeSchId (makeDate,schId) {
  return service({
    url: `/static/frontResApi/exhibit/findAllExhibitMakeSchId/${makeDate}/${schId}`,
    method: 'POST'
  })
}


// WEBPACK FOOTER //
// ./src/libs/api.js